// extracted by mini-css-extract-plugin
module.exports = {"headingLarge":"NotFound_headingLarge_39qNM","textLarge":"NotFound_textLarge_1K6JY","centered":"NotFound_centered_3Augr"};